module.exports = __webpack_public_path__ + "img/nature-64.d0b37f08.jpg";